export default {
  gameColor: '#146ccf',
  futureBet: false,
  systemBet: false,
  additionalBetslipConfig: true,
  betslipConfiguration: {},
  adapters: [
    {
      name: 'GcmAdapter',
      type: 'Product',
      channels: [],
    },
  ],
  bettingType: 'draw',
  ticketType: 'ngsTicket',
  bettingPreview: 'BettingPreviewLuckyX',
  bettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 0, // from config/bets ID
      clientId: 0,
      betType: 'normal', // standard, bet type
      betDisplayName: 'standard', // displayName, from config/bets name
      shortcut: '+',
      inputType: 'text',
      inputFields: 10,
      additionalInputs: ['future'],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 50,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 10,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 0, // from config/bets ID
      clientId: 1,
      betType: 'normal', // standard, bet type
      betDisplayName: 'standard', // displayName, from config/bets name
      shortcut: 's',
      inputType: 'text',
      inputFields: 10,
      additionalInputs: ['future', 'system'],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 50,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 10,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 1,
      clientId: 2,
      betType: 'normal',
      betDisplayName: 'random',
      shortcut: 'r',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 1,
      clientId: 3,
      betType: 'system',
      betDisplayName: 'random_system',
      shortcut: 'w',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future', 'system'],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 1, // from config/bets ID
      clientId: 4,
      betType: 'normal',
      betDisplayName: 'color', // displayName, from config/bets name
      outcomes: ['red', 'blue', 'green', 'yellow', 'purple'],
      shortcut: 'c',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['random', 'future'],
      bettingPreview: {
        betDisplayName: 'color',
        betType: 'normal',
        isColorBet: true,
        outcomes: [
          { outcome: 1, color: 'red', shortcut: '1' },
          { outcome: 2, color: 'blue', shortcut: '2' },
          { outcome: 3, color: 'green', shortcut: '3' },
          { outcome: 4, color: 'yellow', shortcut: '4' },
          { outcome: 5, color: 'purple', shortcut: '5' },
        ],
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 5,
        },
        {
          type: 'pattern',
          expression: /^[1-5]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 1,
      clientId: 5,
      betType: 'system',
      betDisplayName: 'color',
      shortcut: 'l',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future', 'system'],
      bettingPreview: {
        betDisplayName: 'color',
        betType: 'special',
        isColorBet: true,
        outcomes: [
          { outcome: 1, color: 'red', shortcut: '1' },
          { outcome: 2, color: 'blue', shortcut: '2' },
          { outcome: 3, color: 'green', shortcut: '3' },
          { outcome: 4, color: 'yellow', shortcut: '4' },
          { outcome: 5, color: 'purple', shortcut: '5' },
        ],
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 5,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 21,
      clientId: 6,
      betType: 'special',
      betDisplayName: 'first_six_sum',
      limit: 153,
      outcomes: ['under', 'over'],
      shortcut: 'p',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 22, // from config/bets ID
      clientId: 7,
      betType: 'special', // standard, bet type
      betDisplayName: 'first_ball_color', // displayName, from config/bets name
      outcomes: ['red', 'blue', 'green', 'yellow', 'purple'],
      shortcut: 'k',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
        {
          outcome: 3,
          shortcut: '3',
        },
        {
          outcome: 4,
          shortcut: '4',
        },
        {
          outcome: 5,
          shortcut: '5',
        },
      ],
      bettingPreview: {
        betDisplayName: 'first_ball_color',
        betType: 'special',
        isColorBet: true,
        outcomes: [
          { outcome: 1, color: 'red', shortcut: '1' },
          { outcome: 2, color: 'blue', shortcut: '2' },
          { outcome: 3, color: 'green', shortcut: '3' },
          { outcome: 4, color: 'yellow', shortcut: '4' },
          { outcome: 5, color: 'purple', shortcut: '5' },
        ],
      },
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 5,
        },
        {
          type: 'pattern',
          expression: /^[1-5]$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      enabled: true, // from config/bets value
      label: '',
      betId: 23, // from config/bets ID
      clientId: 8,
      betType: 'normal', // standard, bet type
      betDisplayName: 'preball_six', // displayName, from config/bets name
      shortcut: 'g',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 50,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/, // only numbers, must be integer
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
        {
          type: 'length',
          max: 1,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 24,
      clientId: 9,
      betType: 'special',
      betDisplayName: 'first_number_even_odd',
      outcomes: ['even', 'odd'],
      shortcut: 'o',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      enabled: true,
      label: '',
      betId: 25,
      clientId: 9,
      betType: 'special',
      betDisplayName: 'first_number_under_over',
      limit: 25.5,
      outcomes: ['under', 'over'],
      shortcut: 'h',
      inputType: 'text',
      inputFields: 1,
      additionalInputs: ['future'],
      outcomeShortcuts: [
        {
          outcome: 1,
          shortcut: '1',
        },
        {
          outcome: 2,
          shortcut: '2',
        },
      ],
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 1,
        },
        {
          type: 'range',
          min: 1,
          max: 2,
        },
        {
          type: 'pattern',
          expression: /^[1,2]$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
      ],
    },
  ],
  additionalBettingInputs: [
    {
      content: 'bettingInput', // if we've type of component (like input, select, text display...)
      label: 'future_bet',
      clientId: 'future',
      enabled: true,
      betType: 'future', // standard, bet type
      betDisplayName: 'future_bet', // displayName, from config/bets name
      shortcut: 'f',
      inputType: 'text',
      inputFields: 1,
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9]$|^10$/, // only numbers, must be integer
        },
      ],
      betValidations: [],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
        {
          name: 'blur',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      label: 'system',
      clientId: 'system',
      enabled: true,
      systemMarket: true, // To distinct from premier rs input
      betType: 'system',
      betDisplayName: 'system',
      shortcut: null,
      inputType: 'text',
      inputFields: 1,
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 0,
          max: 0,
        },
        {
          type: 'pattern',
          expression: /^[1-9]$|^1[0-4]$/, // allows integers from 1 to 14
        },
      ],
      betValidations: [
        {
          type: 'unique',
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
        {
          name: 'blur',
          handler: {},
        },
      ],
    },
    {
      content: 'bettingInput',
      label: 'random',
      clientId: 'random',
      enabled: true,
      betType: 'random',
      betDisplayName: 'random',
      shortcut: null,
      inputType: 'text',
      inputFields: 1,
      validations: [
        {
          type: 'required',
        },
        {
          type: 'length',
          max: 2,
        },
        {
          type: 'range',
          min: 1,
          max: 10,
        },
        {
          type: 'pattern',
          expression: /^[1-9][0-9]?$/,
        },
      ],
      betValidations: [
        {
          type: 'length',
          max: 1,
          min: 1,
        },
      ],
      events: [
        {
          name: 'input',
          handler: {},
        },
        {
          name: 'keydown',
          handler: {},
        },
        {
          name: 'focus',
          handler: {},
        },
        {
          name: 'blur',
          handler: {},
        },
      ],
    },
  ],
  shortcuts: {
    '+': {
      id: 0, // bettingInput.clientId
      action: 'ticket',
      active: true,
      name: 'new_ticket',
      shortcut: '+',
      order: 1,
    },
    s: {
      id: 1,
      action: 'system',
      active: true,
      name: 'system',
      shortcut: 's',
      order: 2,
    },
    '/': {
      action: 'resetTicket',
      active: true,
      name: 'reset_ticket',
      shortcut: '/',
      order: 2,
    },
    q: {
      action: 'results',
      active: true,
      name: 'results',
      shortcut: 'q',
      order: 3,
    },
    'ctrl + m': {
      action: 'focusFirstBet',
      active: true,
      name: 'focus_first_bet',
      shortcut: 'ctrl + m',
      order: 4,
    },
    'ctrl + s': {
      action: 'editStakePerBet',
      active: true,
      name: 'edit_stake_per_bet',
      shortcut: 'ctrl + s',
      order: 5,
    },
    'ctrl + f': {
      action: 'editFuturePerTicket',
      active: true,
      name: 'edit_future_per_ticket',
      shortcut: 'ctrl + f',
      order: 6,
    },
    'ctrl + b': {
      action: 'focusFirstInput',
      active: true,
      name: 'focus_first_input',
      shortcut: 'ctrl + b',
      order: 7,
    },
    'ctrl + e': {
      action: 'toggleEditMode',
      active: false,
      name: 'toggle_delete_bet_mode',
      shortcut: 'ctrl + e',
      order: 8,
    },
    f: {
      id: 'future',
      action: 'future',
      active: true,
      name: 'future_bet',
      shortcut: 'f',
      order: 9,
    },
    delete: {
      action: 'deleteBet',
      active: false,
      name: 'delete_bet',
      shortcut: 'delete',
      order: 10,
    },
    r: {
      id: 2,
      action: 'random',
      active: true,
      name: 'random',
      shortcut: 'r',
      order: 11,
    },
    w: {
      id: 3,
      action: 'randomSystem',
      active: true,
      name: 'random_system',
      shortcut: 'w',
      order: 13,
    },
    k: {
      id: 4,
      action: 'firstBallColor',
      active: true,
      name: 'first_ball_color',
      shortcut: 'k',
      order: 17,
    },
    c: {
      id: 5,
      action: 'color',
      active: true,
      name: 'color',
      shortcut: 'c',
      order: 17,
    },
    l: {
      id: 6,
      action: 'systemColor',
      active: true,
      name: 'system_color',
      shortcut: 'l',
      order: 17,
    },
    g: {
      id: 7,
      action: 'ballInFirstSix',
      active: true,
      name: 'preball_six',
      shortcut: 'g',
      order: 17,
    },
    o: {
      id: 8,
      action: 'firstNumberEvenOdd',
      active: true,
      name: 'first_number_even_odd',
      shortcut: 'o',
      order: 17,
    },
    p: {
      id: 8,
      action: 'sumOfFirstSixNumbers',
      active: true,
      name: 'first_six_sum',
      shortcut: 'p',
      order: 17,
    },
    h: {
      id: 8,
      action: 'firstNumberUnderOver',
      active: true,
      name: 'first_number_under_over',
      shortcut: 'h',
      order: 17,
    },
    m: {
      action: 'quickBetslipMode',
      active: false,
      name: 'enable_quick_betslip_mode',
      shortcut: 'm',
      order: 22,
    },
  },
  availableTicketActions: [
    {
      status: 'accepted',
      action: ['rebet', 'check', 'copy'],
    },
    {
      status: 'canceled',
      action: ['rebet'],
    },
    {
      status: 'paidout',
      action: ['rebet'],
    },
    {
      status: 'pending',
      action: ['checkStatus'],
    },
    {
      status: 'unknown',
      action: ['checkStatus'],
    },
    {
      status: 'failed',
      action: ['checkStatus'],
    },
    // 7Shop sets this local status, it should be paidout. This will be fixed in the future
    {
      status: 'payedout',
      action: ['rebet'],
    },
  ],
  actionTypes: {
    add: 'TicketPayIn',
    payout: 'TicketPayout',
    cancel: 'TicketCancel',
    copy: 'TicketCopy',
  },
  printLayoutType: {
    add: 'ticketLuckyX',
    payout: 'ticketLuckyXPayout',
    cancel: 'ticketCancel',
    results: 'resultsLuckyX',
  },
};
